module.exports = __webpack_public_path__ + "775c75a4da597ba069c2918f66ad2ddf.svg";